import bundledCompetitionTypeMap from "tokens/build/js/competition-type-map";
import { getCompetitionTypeMap, hasCompetitionTypeMap } from "./useCuiConfig";

export type CompetitionTypeInfoReturnType = {
  name: string;
  displayName?: string;
  sport: string;
  competition: string;
  cuiCompetitionTypeId?: string;
  cuiCompetitionId?: string;
  metadata?: Record<string, unknown>;
} | null | undefined;

function getActiveCompetitionTypeMap(): Record<string, unknown> {
  if (hasCompetitionTypeMap()) return getCompetitionTypeMap()!;
  return bundledCompetitionTypeMap;
}

export const getCompetitionTypeInfo = (competitionType): CompetitionTypeInfoReturnType => {
  const searchTerm = competitionType && typeof competitionType === "string" ? competitionType : "";
  const map = getActiveCompetitionTypeMap();
  if (searchTerm in map) return map[searchTerm] as CompetitionTypeInfoReturnType;
  return null;
};
